<!--
 * @Author: your name
 * @Date: 2021-06-29 09:45:34
 * @LastEditTime: 2025-04-28 18:57:02
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\components\common\sider-bar.vue
-->
<template>
  <div class="out-warp" style="position: relative; width: 120px">
    <div v-if="isPurchase" class="search-box">
      <div class="search-input" :class="{ active: searchMenu }">
        <el-input
          v-model="searchMenu"
          placeholder="请输入"
          @input="searchMenuHandle"
        ></el-input>
        <div class="pr-icon">
          <span v-if="!searchMenu" class="el-icon-search"></span>
          <span v-else class="el-icon-close" @click="clearMenuHandle"></span>
        </div>
        <!-- <el-button @click="clearMenuHandle" icon="el-icon-close" circle></el-button> -->
      </div>
      <div v-if="filterArr.length > 0" class="search-con">
        <div v-if="filterArr.length > 0" class="scroll">
          <div
            v-for="(item, index) in filterArr"
            :key="index"
            @click="toPath(item)"
          >
            <span v-html="hightLightText(item.authName)"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 专采 -->
    <el-scrollbar
      ref="elscrollbar"
      :style="{ height: isPurchase ? 'calc(100% - 54px)' : '100%' }"
    >
      <!-- 滚动条要包裹的内容 -->
      <div>
        <div v-if="isPurchase" class="slidr-bar-wrap">
          <div v-for="(itez, index) in menuList">
            <div v-if="itez.authName !== '工作台'">
              <div class="division">
                {{ itez.authName }}
              </div>
              <!-- :style="{ 'z-index': showSider_bar ? '10000' : '1' }" -->
              <el-menu
                :default-active="activeIndex"
                class="el-menu-vertical-demo"
                background-color="rgb(53,64,82)"
                text-color="#C5C5C5"
                active-text-color="#fff"
                @select="openSubMenu"
              >
                <el-menu-item
                  v-for="(item, index) in itez.childList"
                  :key="index"
                  :index="item.authId.toString()"
                  @click="handleClickMenu(item)"
                >
                  <!-- <img
                    v-if="activeIndex === item.authId.toString()"
                    :src="item.activeIcon"
                    class="icons"
                  />
                  <img v-else :src="item.icon" class="icons" /> -->
                  <eui-icon
                    v-if="activeIndex === item.authId.toString()"
                    style="margin: 0 10px"
                    class="data-icon"
                    :icon="item?.activeIcon || ''"
                    color="#5BC5FF"
                  />
                  <eui-icon
                    v-else
                    style="margin: 0 10px"
                    class="data-icon"
                    :icon="item?.icon || ''"
                    color="#fff"
                  />
                  <span slot="title" class="authname">{{ item.authName }}</span>
                </el-menu-item>
              </el-menu>
            </div>
            <div v-if="itez.authName === '工作台'">
              <!-- :style="{ 'z-index': showSider_bar ? '10000' : '1' }" -->
              <el-menu
                :default-active="activeIndex"
                class="el-menu-vertical-demo"
                background-color="rgb(53,64,82)"
                text-color="#C5C5C5"
                active-text-color="#fff"
                @select="openSubMenu"
              >
                <!-- <el-menu-item style="height: 20px"></el-menu-item> -->
                <el-menu-item
                  v-for="(item, index) in homeMenu"
                  :key="index"
                  :index="item.authId.toString()"
                  @click="handleClickMenu(item)"
                >
                  <eui-icon
                    v-if="activeIndex === item.authId.toString()"
                    style="margin: 0 10px"
                    class="data-icon"
                    :icon="item?.activeIcon || ''"
                    color="#5BC5FF"
                  />
                  <eui-icon
                    v-else
                    style="margin: 0 10px"
                    class="data-icon"
                    :icon="item?.icon || ''"
                    color="#fff"
                  />
                  <span slot="title" class="authname">
                    {{ item.authName }}
                  </span>
                  <!-- <div slot="title" class="triangle-left" v-if="activeIndex === item.authId.toString()"></div> -->
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <!-- 非专采 -->
        <div v-else class="slidr-bar-wrap">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical"
            background-color="rgb(53,64,82)"
            text-color="#fff"
            active-text-color="#fff"
            :style="{ 'z-index': showSider_bar ? '10000' : '1' }"
            @select="openSubMenu"
          >
            <!-- <el-menu-item style="height: 20px"></el-menu-item> -->
            <el-menu-item
              v-for="(item, index) in menuList"
              :key="index"
              :index="item.authId.toString()"
              @click="handleClickMenu(item)"
            >
              <eui-icon
                v-if="activeIndex === item.authId.toString()"
                style="margin: 0 10px"
                class="data-icon"
                :icon="item?.activeIcon || ''"
                color="#5BC5FF"
              />
              <eui-icon
                v-else
                style="margin: 0 10px"
                class="data-icon"
                :icon="item?.icon || ''"
                color="#fff"
              />
              <span slot="title" class="authname">{{ item.authName }}</span>
              <!-- <div slot="title" class="triangle-left" v-if="activeIndex === item.authId.toString()"></div> -->
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </el-scrollbar>

    <!-- <sider-right style="text-align:left;" :active-index="activeIndex" :menu-list="subMenuList"></sider-right> -->
  </div>
</template>

<script>
// import SiderRight from './sider-right.vue'
// import { ecBaseUrl } from '@/modules/projectA/api/config.js';
import _ from 'lodash';
import Api from '@/modules/projectA/api/filing';
import bus from './bus';

export default {
  name: 'Sider',
  components: {}, // SiderRight
  data() {
    return {
      searchMenu: '',
      cloneMenuList: [],
      filterArr: [],

      homeMenu: [],
      isPurchase: false,
      activeIndex: localStorage.getItem('firstIndex')
        ? localStorage.getItem('firstIndex')
        : '',
      menuList: [],
      subMenuList: [],
      defaultHeight: {
        height: '',
      },
      slideMenuList: [
        {
          name: '首页',
          icon: 'eicon-home-unselected',
          activeIcon: 'eicon-home-selected',
        },
        {
          name: '企业',
          icon: 'eicon-company-unselected',
          activeIcon: 'eicon-company-selected',
        },
        {
          name: '用户',
          icon: 'eicon-user-unselected',
          activeIcon: 'eicon-user-selected',
        },
        {
          name: '商品',
          icon: 'eicon-product-unselected',
          activeIcon: 'eicon-product-selected',
        },
        {
          name: '商城管理',
          icon: 'eicon-shop-unselected',
          activeIcon: 'eicon-shop-selected',
        },
        {
          name: '协议',
          icon: 'eicon-xy-unselected',
          activeIcon: 'eicon-xy-selected',
        },
        {
          name: '招标管理',
          icon: 'eicon-zbgl-unselected',
          activeIcon: 'eicon-zbgl-selected',
        },
        {
          name: '订单',
          icon: 'eicon-order1-unselected',
          activeIcon: 'eicon-order1-unselected',
        },
        {
          name: '订单管理',
          icon: 'eicon-a-dingdanguanli',
          activeIcon: 'eicon-r-dingdanguanli1',
        },
        {
          name: '支付',
          icon: 'eicon-pay-unselected',
          activeIcon: 'eicon-pay-selected',
        },
        {
          name: '物流',
          icon: 'eicon-wl-unselected',
          activeIcon: 'eicon-wl-selected',
        },
        {
          name: '对账管理',
          icon: 'eicon-duizhangguanlimoren1',
          activeIcon: 'eicon-duizhangguanlixuanzhong1',
        },
        {
          name: '备案申请',
          icon: 'eicon-beianshenqingmoren',
          activeIcon: 'eicon-beianshenqingxuanzhong',
        },
        {
          name: '增值服务',
          icon: 'eicon-zzfw-unselected',
          activeIcon: 'eicon-zzfw-selected',
        },
        {
          name: '设置',
          icon: 'eicon-set-unselected',
          activeIcon: 'eicon-set-selected',
        },
        {
          name: '跨境业务',
          icon: 'eicon-gjfw-unselected',
          activeIcon: 'eicon-gjfw-selected',
        },
        {
          name: 'EC业务',
          icon: 'eicon-epec-unselected',
          activeIcon: 'eicon-epec-selected',
        },
        {
          name: '数据统计',
          icon: 'eicon-tj-unselected',
          activeIcon: 'eicon-tj-selected',
        },
        {
          name: '统计',
          icon: 'eicon-tj-unselected',
          activeIcon: 'eicon-tj-selected',
        },
        {
          name: '专属采购',
          icon: 'eicon-gwc-unselected',
          activeIcon: 'eicon-gwc-selected',
        },
        {
          name: '询价管理',
          icon: 'eicon-xjgl-unselected',
          activeIcon: 'eicon-xjgl-selected',
        },
        {
          name: '煤炭应用',
          icon: 'eicon-mtyy1-unselected',
          activeIcon: 'eicon-mtyy1-selected',
        },
        {
          name: '价格',
          icon: 'eicon-price-unselected',
          activeIcon: 'eicon-price-selected',
        },
        {
          name: '交货',
          icon: 'eicon-jiaohuomoren',
          activeIcon: 'eicon-jiaohuoxuanzhong',
        },
        {
          name: '活动管理',
          icon: 'eicon-hdgl-unselected',
          activeIcon: 'eicon-hdgl-selected',
        },
        {
          name: '报价管理',
          icon: 'eicon-l-baojiaguanli',
          activeIcon: 'eicon-l-baojiaguanli',
        },
        {
          name: '采购计划',
          icon: 'eicon-cgfs-unselected',
          activeIcon: 'eicon-cgfs-selected',
        },
        {
          name: '采购协议',
          icon: 'eicon-cgxy-unselected',
          activeIcon: 'eicon-cgxy-selected',
        },
        {
          name: '商城配置',
          icon: 'eicon-scpz-unselected',
          activeIcon: 'eicon-scpz-selected',
        },
        {
          name: '委托招标',
          icon: 'eicon-wtzb-unselected',
          activeIcon: 'eicon-wtzb-selected',
        },
        {
          name: '销售协议',
          icon: 'eicon-xsxy-unselected',
          activeIcon: 'eicon-xsxy-selected',
        },
        {
          name: '需求计划',
          icon: 'eicon-xqgl-unselected',
          activeIcon: 'eicon-xqgl-selected',
        },
        {
          name: '供应商资源',
          icon: 'eicon-gyszy-unselected',
          activeIcon: 'eicon-gyszy-selected',
        },
        {
          name: '审批管理',
          icon: 'eicon-spgl-unselected',
          activeIcon: 'eicon-spgl-selected',
        },
        {
          name: '投标',
          icon: 'eicon-tb-unselected',
          activeIcon: 'eicon-tb-selected',
        },
        {
          name: '备案管理',
          icon: 'eicon-beianshenqingmoren',
          activeIcon: 'eicon-beianshenqingxuanzhong',
        },
        {
          name: '数据报表',
          icon: 'eicon-r-l-shujubaobiao',
          activeIcon: 'eicon-r-shujubaobiao',
        },
        {
          name: '溯源管理',
          icon: 'eicon-r-l-yclgl',
          activeIcon: 'eicon-r-yclgl',
        },
        {
          name: '公告管理',
          icon: 'eicon-notice-normal',
          activeIcon: 'eicon-notice-press',
        },
        {
          name: '数据收集',
          icon: 'eicon-l-lvsepingjia',
          activeIcon: 'eicon-lvsepingjia',
        },
        // eicon-notice-normal
      ],
      showSider_bar: true,
      path: '',
    };
  },
  computed: {
    menuListData() {
      return this.$store.state.MENUINFO;
    },
    onRoutes() {
      return this.$route.path;
    },
    // 监听侧边栏菜单层级是否隐藏
    changSider_bar() {
      return this.$store.state.sider_bar;
    },
  },
  watch: {
    $route(newVal) {
      console.log(newVal, 'route');
      this.path = newVal.path;
    },
    menuListData: {
      immediate: true,
      async handler(newval) {
        if (!newval?.childList?.length) return;

        this.isPurchase = newval.isPurchase;
        const whiteListResult = await Api.isWhiteList();

        if (whiteListResult.code === '200') {
          this.handleRemoveItemFromList(whiteListResult.data, newval);
        }

        this.menuList = newval.childList;
        // 处理滚动条位置
        this.$nextTick(() => {
          const div = this.$refs.elscrollbar.$refs.wrap;
          div.scrollTop = 0;
        });

        this.setHomeMenu(newval.childList[0]);
        this.setActiveIndex();

        const { authId } = this.$route.query;
        if (authId) {
          const currentList = this.getParentsById(
            this.menuList,
            Number(authId)
          );
          setTimeout(() => this.handleRouteQuery(currentList, authId), 0);
        } else {
          this.setDefaultSubMenuList(!this.isPurchase);
        }

        this.menuIcon();
        this.cloneMenuList = this.getData(this.menuList);
      },
      /* async handler(newval) {
        if (newval?.childList?.length > 0) {
          this.isPurchase = newval.isPurchase;
          console.log(newval.childList, 'newval.childList');

          const result = await Api.isWhiteList();
          if (result.code === '200') {
            // 3 authName "备案管理"
            if (!result.data) {
              if (newval.isPurchase) {
                const outIndex = newval.childList.findIndex(
                  (item) => item.authName === '企业管理'
                );
                if (outIndex > -1) {
                  const list = newval.childList[outIndex];
                  const index = list.childList.findIndex(
                    (item) => item.authName === '备案管理'
                  );
                  if (index > -1) {
                    list.childList.splice(index, 1);
                  }
                }
              } else {
                const index = newval.childList.findIndex(
                  (item) => item.authName === '备案管理'
                );
                if (index > -1) {
                  newval.childList.splice(index, 1);
                }
              }
            }
          }

          this.menuList = newval.childList;
          // 处理滚动条位置不对的问题
          this.$nextTick(() => {
            const div = this.$refs.elscrollbar.$refs.wrap;
            div.scrollTop = 0;
          });

          this.homeMenu = [
            {
              ...newval.childList[0],
              name: '工作台',
              icon: 'eicon-gzt-unselected',
              activeIcon: 'eicon-gzt-selected',
            },
          ];
          if (this.isPurchase && this.$route.path === '/dashboard') {
            this.activeIndex = '12227';
          } else {
            this.activeIndex = localStorage.getItem('firstIndex')
              ? localStorage.getItem('firstIndex')
              : '10136';
          }
          console.log(this.activeIndex, 'this.activeIndex)');
          bus.$emit('activeIndex', this.activeIndex);
          this.$emit('menuChange', this.activeIndex);

          const { authId = '' } = this.$route.query;
          if (authId) {
            const currentList = this.getParentsById(
              this.menuList,
              Number(authId)
            );
            setTimeout(() => {
              console.log(currentList, 'currentList11111');
              if (authId == 12227) {
                this.$store.commit('getRightBar', false);
                this.activeIndex = '12227';
                return;
              }
              // this.$store.commit('getRightBar', item?.childList?.length > 0);
              console.log(
                currentList[2]?.childList,
                'currentList[2].childList'
              );
              bus.$emit('menuList', currentList[2]?.childList);
              this.activeIndex = currentList[2]?.authId;
              bus.$emit('activeIndex', currentList[2]?.authId);
              this.$emit('menuChange', currentList[2]?.authId);
            }, 0);

            this.menuIcon();
            this.cloneMenuList = this.getData(this.menuList);
            return;
          }

          if (!this.isPurchase) {
            if (localStorage.getItem('firstIndex')) {
              for (let i = 0; i < this.menuList.length; i++) {
                if (this.menuList[i].authId.toString() == this.activeIndex)
                  this.subMenuList = this.menuList[i].childList;
                bus.$emit('menuList', this.subMenuList);
              }
            } else {
              this.subMenuList = this.menuList[0].childList;
              bus.$emit('menuList', this.subMenuList);
            }
          } else {
            const newArr = [];
            this.menuList.forEach((item) => {
              if (item?.childList?.length > 0) {
                item.childList.forEach((iten) => {
                  newArr.push(iten);
                });
              }
            });
            if (localStorage.getItem('firstIndex')) {
              for (let i = 0; i < newArr.length; i++) {
                if (newArr[i].authId.toString() == this.activeIndex)
                  this.subMenuList = newArr[i].childList;
                bus.$emit('menuList', this.subMenuList);
              }
            } else {
              this.subMenuList = this.menuList[0].childList;
              bus.$emit('menuList', this.subMenuList);
            }
          }
          this.menuIcon();
          this.cloneMenuList = this.getData(this.menuList);
        }
      }, */
    },
    changSider_bar(newVal, oldVal) {
      // 监听左边侧边栏层级
      console.log(newVal, oldVal);
      this.showSider_bar = newVal;
    },
  },
  methods: {
    // 移除指定菜单项
    handleRemoveItemFromList(isWhiteListed, newval) {
      if (!isWhiteListed) {
        const targetAuthName = '备案管理';
        const removeFn = (list) => {
          const index = list.findIndex(
            (item) => item.authName === targetAuthName
          );
          if (index > -1) list.splice(index, 1);
        };

        if (newval.isPurchase) {
          const outIndex = newval.childList.findIndex(
            (item) => item.authName === '企业管理'
          );
          if (outIndex > -1) {
            removeFn(newval.childList[outIndex].childList);
          }
        } else {
          removeFn(newval.childList);
        }
      }
    },

    // 设置工作台菜单
    setHomeMenu(item) {
      this.homeMenu = [
        {
          ...item,
          name: '工作台',
          icon: 'eicon-gzt-unselected',
          activeIcon: 'eicon-gzt-selected',
        },
      ];
    },

    // 设置激活索引
    setActiveIndex() {
      if (this.isPurchase && this.$route.path === '/dashboard') {
        this.activeIndex = '12227';
      } else {
        this.activeIndex = localStorage.getItem('firstIndex') || '10136';
      }

      bus.$emit('activeIndex', this.activeIndex);
      this.$emit('menuChange', this.activeIndex);
    },

    // 根据路由查询参数处理菜单
    handleRouteQuery(currentList, authId) {
      if (authId === '12227') {
        this.$store.commit('getRightBar', false);
        this.activeIndex = '12227';
        return;
      }

      const subMenuList = currentList[2]?.childList;
      if (subMenuList) {
        bus.$emit('menuList', subMenuList);
        this.activeIndex = currentList[2]?.authId;
        bus.$emit('activeIndex', currentList[2]?.authId);
        this.$emit('menuChange', currentList[2]?.authId);
      }
    },

    // 设置默认子菜单列表
    setDefaultSubMenuList(isNotPurchase) {
      const sourceList = isNotPurchase
        ? this.menuList
        : this.flattenMenuList(this.menuList);

      if (localStorage.getItem('firstIndex')) {
        for (let i = 0; i < sourceList.length; i++) {
          if (sourceList[i].authId.toString() === this.activeIndex) {
            this.subMenuList = sourceList[i].childList;
            bus.$emit('menuList', this.subMenuList);
            break;
          }
        }
      } else {
        this.subMenuList = sourceList[0].childList;
        bus.$emit('menuList', this.subMenuList);
      }
    },

    // 将嵌套菜单扁平化
    flattenMenuList(menuList) {
      const newArr = [];
      menuList.forEach((item) => {
        if (item?.childList?.length > 0) {
          item.childList.forEach((iten) => {
            newArr.push(iten);
          });
        }
      });
      return newArr;
    },

    // --------
    getParentsById(list, authId) {
      for (const i in list) {
        const item = list[i];
        if (item.authId === authId) return [item];
        if (item.childList) {
          const node = this.getParentsById(item.childList, authId);
          if (node !== undefined) return node.concat(item);
        }
      }
    },
    getData(data, result = []) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].authCode) {
          result.push(data[i]);
        }
        if (data[i].childList?.length > 0) {
          this.getData(data[i]?.childList, result);
        }
      }
      return result;
    },
    getAllParentNodes(val, tree, attr, newArr = []) {
      // 如果搜索关键字为空直接返回源数据
      if (!(tree.length && val)) {
        return tree;
      }
      for (const item of tree) {
        // 匹配到关键字的逻辑
        // console.log(item[attr], 'item[attr]');
        if (item[attr] && item[attr].includes(val)) {
          // 如果匹配到就在数值中添加记录
          newArr.push(item);
          // 匹配到了就退出循环了此时如果有子集也会一并带着
          continue;
        }
        // 如果父级节点没有匹配到就看看是否有子集，然后做递归
        if (item.childList && item.childList.length) {
          // 缓存递归后的子集数组
          const subArr = this.getAllParentNodes(val, item.childList, attr);
          // 如果子集数据有匹配到的节点
          if (subArr && subArr.length) {
            // 关键逻辑，缓存父节点同时将递归后的子节点作为新值
            const node = { ...item, childList: subArr };
            // 添加进数组
            newArr.push(node);
          }
        }
      }
      return newArr;
    },
    searchMenuHandle: _.debounce(function () {
      if (!this.searchMenu) {
        this.clearMenuHandle();
        return;
      }
      // if (!this.searchMenu) return;
      const menuList = [...this.cloneMenuList];
      const filterArr = menuList.filter((item) =>
        item.authName.includes(this.searchMenu)
      );
      this.filterArr = [...filterArr];
      console.log(filterArr, 'filterArr');
    }, 200),
    hightLightText(text) {
      if (text) {
        const reg = new RegExp(this.searchMenu, 'gi'); // 动态正则表达式
        return text.replace(
          reg,
          `<span class="menu-active">${this.searchMenu}</span>`
        ); // 使用replace替换
      }
    },
    clearMenuHandle() {
      this.searchMenu = '';
      this.filterArr = [];
    },
    toPath(item) {
      this.filterArr = [];
      this.searchMenu = '';
      if (item.authCode.indexOf('http') != -1) {
        window.open(item.authCode, '_blank');
      } else {
        this.$router.push(item.authCode);
      }
    },
    menuIcon() {
      if (!this.menuListData?.childList) {
        return;
      }

      // let menuList = this.menuListData.childList;
      let menuList = [];
      if (this.isPurchase) {
        this.menuListData.childList.forEach((item) => {
          if (item?.childList) {
            item.childList.forEach((iten) => {
              menuList.push(iten);
            });
          }
        });
      } else {
        menuList = this.menuListData.childList;
      }

      // let menuList = this.menuListData.childList;
      const { slideMenuList } = this;
      if (menuList !== []) {
        for (const i of menuList) {
          for (const j of slideMenuList) {
            if (i.authName == j.name) {
              Object.assign(i, {
                icon: j.icon,
                activeIcon: j.activeIcon,
              });
            }
          }
        }
      }
    },
    openSubMenu(index) {
      this.activeIndex = index;
      bus.$emit('activeIndex', this.activeIndex);
      this.$emit('menuChange', index);
    },

    handleClickMenu(item) {
      // console.log(item, '菜单信息');
      this.$store.commit('getRightBar', item?.childList?.length > 0);

      bus.$emit('collapse', item?.childList?.length > 0);

      if (item.authId === 350) {
        window.location.href = item.authCode;
      }
      // 前端逻辑跳转判断
      // 内外部供应商，点击EC业务平台进入EC融合页面
      /* if (item.authName == 'EC业务') {
        let userInfo = this.$store.state.USERINFO;
        if (
          userInfo.memberIdentity == 'supplier' ||
          userInfo.memberIdentity == 'double_identity'
        ) {
          // item.authCode = `https://ec.epec.com/EnquireAction!toEnquirebillList.do`;
          if (process.env.NODE_ENV === 'production') {
            item.authCode = `${ecBaseUrl}/EnquireAction!toEnquirebillList.do`;
          } else {
            item.authCode = this.$store.state.MENUINFO.childList.find(
              (i) => i.authName == 'EC业务'
            ).authCode;
          }

          // if (userInfo.internalFlag === 1) {
          //   item.authCode = "https://ec.sinopec.com/desktop/index_.jsp"
          // } else {
          //   item.authCode = "https://ec.epec.com/EnquireAction!toEnquirebillList.do"
          // }
        }
      } */

      if (item.authCode && item.authCode.substr(0, 4) === 'http') {
        let url = item.authCode;
        if (process.env.environment === 'production') {
          url = url
            .replace(/http:/g, 'https:')
            .replace(/uat-mall.epec.com/g, 'mall.epec.com')
            .replace(/uat-member.epec.com/g, 'member.epec.com');
        }
        window.open(url);
      }
      if (item.authCode == '/dashboard') {
        this.$router.push({
          path: item.authCode,
        });
      } else {
        localStorage.setItem('firstIndex', item.authId.toString());
        this.subMenuList = item.childList;

        bus.$emit('menuList', this.subMenuList);
      }
    },
    // 定义方法，获取高度减去头尾
    // getHeight() {
    // 	this.defaultHeight.height = window.innerHeight - 90 + "px";
    // }
  },
  created() {
    const { authId = '' } = this.$route.query;
    // this.activeIndex = localStorage.getItem('firstIndex') || '';
    // console.log(this.activeIndex, 'activeIndex');
    bus.$emit('activeIndex', this.activeIndex);
    if (this.isPurchase && authId) {
      const currentList = this.getParentsById(this.menuList, Number(authId));
      setTimeout(() => {
        console.log(currentList, 'currentList11111');
        console.log(currentList[2].childList, 'currentList[2].childList');
        bus.$emit('menuList', currentList[2].childList);
      }, 0);
    }
  },
  mounted() {
    bus.$on('authId', (res) => {
      this.activeIndex = String(res);
    });
  },
};
</script>
<style lang="scss" scoped>
.out-warp {
  position: relative;
  background: #354052;
  width: 120px;
  /* element滚动条组件 隐藏水平滚动条 */
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
    margin-right: -21px !important;
    .division {
      background-color: rgb(53, 64, 82);
      color: #fff;
      text-align: left;
      margin-left: 6px;
      font-size: 12px;
      color: #999;
      margin-top: 20px;
    }
  }
  ::v-deep .is-horizontal {
    display: none;
  }
  .search-box {
    position: relative;
    width: 120px;
    padding: 10px;
    .search-con {
      width: 170px;
      height: 190px;
      font-size: 14px;
      color: #333;
      position: absolute;
      left: 10px;
      top: 52px;
      background: #fff;
      z-index: 100000;
      border: 1px solid #d9d9d9;
      padding: 20px 8px;
      .scroll {
        height: 100%;
        overflow: auto;
        div {
          margin-top: 20px;
          line-height: 1;
          cursor: pointer;
          &:first-child {
            margin-top: 0;
          }
        }
        ::v-deep span.menu-active {
          color: #2587ff;
        }
      }
    }
    .search-input {
      display: flex;
      height: 34px;
      border: 1px solid #d9d9d9;
      .pr-icon {
        display: flex;
        align-items: center;
        color: #999;
        padding-right: 8px;
        font-size: 14px;
      }
      &.active {
        ::v-deep .el-input {
          .el-input__inner {
            border: none;
            background: #fff;
            color: #333;
          }
        }
        .pr-icon {
          background: #fff;
          .el-icon-close {
            border-radius: 50%;
            padding: 2px;
            background: #c5c5c5;
            font-size: 12px;
            color: #fff;
            font-size: 12px;
          }
        }
        ::v-deep .el-button {
          background: #fff;
          border: none;
          color: #fff;
        }
      }
      // .search-input {
      ::v-deep .el-input {
        .el-input__inner {
          border: none;
          background: #354052;
          color: #fff;
        }
      }
      ::v-deep .el-button {
        background: #354052;
        border: none;
        color: #fff;
        padding: 0;
        padding-right: 9px;
      }
      // }
    }
  }
}
::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.slidr-bar-wrap {
  // height: 100vh;
  overflow: auto;
  // height: 94vh;
  height: calc(100%);
}

.icons {
  width: 12px;
  height: 12px;
  margin: 0 10px;
  background-size: 100% 100%;
  z-index: 1000;
}

.el-menu-item {
  padding: 0;
  display: flex;
  align-items: center;
}

.authname {
  flex: 2;
}

.el-menu-vertical-demo {
  width: 120px;
  border-left: 1px solid #42649c;
  margin-left: 6px;
  // height: calc(100% - 50px);
  // height: calc(100% - -8px);
  height: 100%;

  ::v-deep .el-menu-item {
    padding: 0px !important;
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: #ffffff;
    height: 36px;

    &:focus {
      //background: #2587ff !important;
      color: #5bc5ff !important;
      background-color: #354052 !important;
    }

    &:hover {
      //background: #2587ff !important;\
      color: #5bc5ff !important;
      background-color: #354052 !important;
    }
  }

  ::v-deep .is-active {
    // background: #2587ff !important;
    color: #5bc5ff !important;
    background-color: #354052;
    &::before {
      content: '';
      display: inline-block;
      width: 1px;
      height: 20px;
      background: #5bc5ff;
      position: absolute;
      left: -1px;
      top: 6px;
    }
  }
}

.el-menu-vertical {
  z-index: 10000;
  width: 120px;
  // height: calc(100% - 50px);
  // height: calc(100% - -8px);
  height: 100%;
  overflow: hidden;
  overflow-y: auto;

  ::v-deep .el-menu-item {
    padding-left: 0 !important;
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: #ffffff;

    &:focus {
      background: #2587ff !important;
    }

    &:hover {
      background: #2587ff !important;
    }
  }

  ::v-deep .is-active {
    background: #2587ff !important;
  }
}

::v-deep .el-menu {
  border-right: solid 0px #ffffff !important;
}

//
</style>
